import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'

interface Data {
  pdf: string
}

@Component({
  selector: 'app-manual-empresarios-modal',
  imports: [],
  templateUrl: './manual-empresarios-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManualEmpresariosModalComponent {
  data: Data = inject(DIALOG_DATA)
  dialogRef = inject(DialogRef)
  pdfUrl: SafeResourceUrl = inject(DomSanitizer).bypassSecurityTrustResourceUrl(this.data.pdf)
}
